<template>
    <div class="relative inline-block text-left">
        <div @click="open = !open">
            <button
                type="button"
                class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <slot name="icon"></slot>
            </button>
        </div>

        <!-- to close when clicked on space around it-->
        <button
            class="fixed inset-0 h-full w-full cursor-default focus:outline-none"
            v-if="open"
            @click="open = false"
            tabindex="-1"
        ></button>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <!--            <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg" v-if="open">-->
            <div
                class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 z-10"
                v-if="open"
            >
                <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5">
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    props: {
        avatar: {
            type: String,
            default: '',
        },
    },
    methods: {
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
